import My from './My'
import System from './System'
import NewSystem from './NewSystem'
import Tab from './Tab'

export {
    My,
    System,
    NewSystem,
    Tab,
}


// WEBPACK FOOTER //
// ./src/components/message/index.js